import { render, staticRenderFns } from "./openid-get.vue?vue&type=template&id=5ed357f2&scoped=true"
import script from "./openid-get.vue?vue&type=script&lang=js"
export * from "./openid-get.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed357f2",
  null
  
)

export default component.exports